import React, { useContext, useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import ReviewBusinessForm from "../../components/Business/ReviewBusinessForm";
import userService from "../../services/userService";
import { GlobalContext } from "../../utility/GlobalContext";
import axios from "axios";
import businessService from "../../services/businessService";
import { useHistory } from "react-router-dom";
import ReviewCreatorForm from "../../components/Creator/ReviewCreatorForm";
import socialService from "../../services/socialService";

export default function CreateAndReviewCreator(props) {
  const state = props.state;
  const loading = props.loading;
  const history = useHistory();
  const [newSocial, setNewSocial] = useState(null);
  const [platform, setPlatform] = useState("");
  const [handle, setHandle] = useState("");

  const createSocial = async (e) => {
    e.preventDefault();
    if (!platform) {
      toast.error("Pick a valid platform");
      return;
    }
    if (!handle) {
      toast.error("Enter a valid handle");
      return;
    }
    socialService
      .addSocial(handle, platform, state.jwt, true)
      .then((response) => {
        setNewSocial(response.data);
      })
      .catch((err) => {
        toast.error(err.response.data.msg || "Error occurred")
      });
  };

  const forwardToBusiness = () => {
    history.push(`${platform}/${handle}`);
  };

  if (loading) {
    return <h3>Loading</h3>;
  }
  if (
    !state.user.Business ||
    (state.user.Business && state.user.Business.status != "claimed")
  ) {
    return (
      <div className="col-6">
        <h3>Sorry, your business is not verified</h3>
        <p>
          To write a review for a social make sure you add a business and follow
          the instructions so we know you own it
        </p>
      </div>
    );
  }
  if (!newSocial) {
    return (
      <div className="col-6">
        <h3>What is their social handle</h3>
        <Form>
          <Form.Group controlId="formName">
            <Form.Label>Handle</Form.Label>
            <Form.Control
              onChange={(e) => setHandle(e.target.value)}
              type="text"
              placeholder="@handlename"
            />
          </Form.Group>
          <div className="mb-3">
            <Form.Label>Platform:</Form.Label>
            <Form.Check
              onClick={() => {
                setPlatform("tiktok");
              }}
              name="handleOptions"
              type="radio"
              label="Tiktok"
              id="tiktok"
            />
            <Form.Check
              onClick={() => {
                setPlatform("instagram");
              }}
              name="handleOptions"
              type="radio"
              label="Instagram"
              id="instagram"
            />
          </div>

          <Button variant="primary" type="submit" onClick={createSocial}>
            Submit
          </Button>
        </Form>
      </div>
    );
  }
  return (
    <div>
      {/* <h3>A new review</h3> */}
      {state.user.type === "business" && (
        <ReviewCreatorForm
          jwt={state.jwt}
          currentUserID={state.currentUserID}
          social={newSocial}
          businessID={state.user.Business.id}
          user={state.user}
          onReviewSucceeded={forwardToBusiness}
        />
      )}
    </div>
  );
}
